import { Outlet } from "react-router";

export default function StoreConnect() {
  return <Outlet/>
}